import { setRecentlyProducts } from 'helpers/recently-product'
import ProductVendorModal from 'modules/product-vendor/product-vendor-modal'
import register from 'preact-custom-element'
import AnchorSection from 'snippets/anchor-section/anchor-section'
import ProductBadge from 'snippets/product-badge/product-badge'
import ProductForm from 'snippets/product-form/product-form'
import ProductInfo from 'snippets/product-info/product-info'
import ProductLookBook from 'snippets/product-lookbook/product-lookbook'
import ProductShipping from 'snippets/product-shipping/product-shipping'
import { isWishlistEnabled } from 'helpers/wishlist'

let devtools
if (process.env.NODE_ENV === 'development') {
  devtools = require('preact/devtools')
}

class ProductMain extends HTMLElement {
  constructor() {
    super()
    setRecentlyProducts(this.dataset.handle)

    if (localStorage.getItem('return_to')) {
      localStorage.removeItem('return_to')
    }

    const initWishlist = () => {
      if (isWishlistEnabled()) {
        this.initSwymWishlistRemoval()
      }
    }

    if (window.GM_STATE?.onReady) {
      window.GM_STATE.onReady(initWishlist)
    } else {
      initWishlist()
    }

    // Track mounting state to prevent concurrent attempts
    this._isMountingPreezie = false
  }

  connectedCallback() {
    setTimeout(() => this.mountPreezieWidget(), 100)
  }

  initSwymWishlistRemoval() {
    if (!window.SwymCallbacks) window.SwymCallbacks = []

    if (!window._swymAutoInitPatched) {
      window._swymAutoInitPatched = true

      window.SwymCallbacks.push(function (swat) {
        try {
          if (swat && swat.config) {
            swat.config.autoReinitialize = false
          }

          if (swat.ui && typeof swat.ui.loadUIBundle === 'function') {
            const originalLoadUI = swat.ui.loadUIBundle
            swat.ui.loadUIBundle = function (...args) {
              try {
                if (
                  args[0] &&
                  typeof args[0] === 'string' &&
                  args[0].includes('wishlist')
                ) {
                  return
                }
                return originalLoadUI.apply(this, args)
              } catch (err) {
                console.error('Error:', err)
              }
            }
          }
        } catch (err) {
          console.error('Error:', err)
        }
      })
    }

    const initSwymUI = (swatInstance) => {
      this.setupWishlistRemoval(swatInstance)
    }

    this.initSwymUI = initSwymUI
    window.SwymCallbacks.push(this.initSwymUI.bind(this))

    document.addEventListener('page:loaded', () => {
      if (window._swat && window._swat.config) {
        window._swat.config.autoReinitialize = false
      }
    })
  }

  setupWishlistRemoval(swat) {
    this.swatInstance = swat

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.attachWishlistRemovalListener(entry.target, swat)
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    )

    const swymButton = document.querySelector(
      '.swym-button.swym-add-to-wishlist-view-product'
    )
    if (swymButton) {
      observer.observe(swymButton)
    }

    this.checkExistingSwymButton(swat)
    this.setupGlobalEventDelegation(swat)
  }

  setupGlobalEventDelegation(swat) {
    const handleClick = (event) => {
      const button = event.target.closest(
        '.swym-button.swym-add-to-wishlist-view-product'
      )
      if (!button) return

      if (button.dataset.removing === 'true') {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        return
      }

      if (button.classList.contains('swym-added')) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        this.handleWishlistRemoval(event, swat, button)
      }
    }

    this._globalClickHandler = handleClick
    document.addEventListener('click', handleClick, true)

    this.setupSwymAddedMonitor()
  }

  setupSwymAddedMonitor() {
    const button = document.querySelector(
      '.swym-button.swym-add-to-wishlist-view-product'
    )
    if (!button) return

    let lastKnownState = {
      hasSwymAdded: button.classList.contains('swym-added'),
      timestamp: Date.now()
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const hasSwymAdded = button.classList.contains('swym-added')
          const oldValue = mutation.oldValue || ''
          const hadSwymAdded = oldValue.includes('swym-added')

          if (hasSwymAdded && !hadSwymAdded) {
            if (button.dataset.removing === 'true') {
              button.classList.remove('swym-added')
              if (button.getAttribute('data-swaction')) {
                button.removeAttribute('data-swaction')
              }
            }
          }

          lastKnownState = {
            hasSwymAdded,
            timestamp: Date.now()
          }
        }
      })
    })

    observer.observe(button, {
      attributes: true,
      attributeFilter: ['class', 'data-swaction'],
      attributeOldValue: true
    })

    this._swymMonitor = observer
  }

  checkExistingSwymButton(swat) {
    const swymButton = document.querySelector(
      '.swym-button.swym-add-to-wishlist-view-product'
    )
    if (swymButton && swymButton.classList.contains('swym-added')) {
      this.attachWishlistRemovalListener(swymButton, swat)
    }
  }

  attachWishlistRemovalListener(button, swat) {
    const handleClick = (event) => {
      if (button.classList.contains('swym-added')) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        this.handleWishlistRemoval(event, swat, button)
      }
    }

    const handleMouseDown = (event) => {
      if (button.classList.contains('swym-added')) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        this.handleWishlistRemoval(event, swat, button)
      }
    }

    if (button._clickHandler) {
      button.removeEventListener('click', button._clickHandler, true)
    }
    if (button._mouseDownHandler) {
      button.removeEventListener('mousedown', button._mouseDownHandler)
    }

    button._clickHandler = handleClick
    button._mouseDownHandler = handleMouseDown
    button._swatInstance = swat

    button.addEventListener('click', handleClick, true)
    button.addEventListener('mousedown', handleMouseDown)
  }

  handleWishlistRemoval(event, swat, button) {
    if (!button || !button.classList) return

    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()

    button.dataset.removing = 'true'

    const originalSwaction = button.getAttribute('data-swaction')
    if (originalSwaction) button.removeAttribute('data-swaction')

    const product = {
      epi: Number(button.getAttribute('data-variant-id')),
      empi: Number(button.getAttribute('data-product-id')),
      du: button.getAttribute('data-product-url')
    }

    if (!product.epi || !product.empi || !product.du) {
      console.error('Missing required product data')
      if (originalSwaction) button.setAttribute('data-swaction', originalSwaction)
      button.dataset.removing = 'false'
      return
    }

    // Use the global removeFromWishlist function
    const originalAttributes = {
      action: originalSwaction || button.getAttribute('data-swaction'),
      hadSwymButton: button.classList.contains('swym-button')
    }

    if (window.removeFromWishlist && typeof window.removeFromWishlist === 'function') {
      window.removeFromWishlist(swat, button, originalAttributes)
    } else {
      if (originalSwaction) button.setAttribute('data-swaction', originalSwaction)
      button.dataset.removing = 'false'
    }
  }

  /**
   * Mounts the Preezie widget with retry logic and improved error handling
   * @param {number} attempt - Current attempt number (0-based)
   */
  mountPreezieWidget(attempt = 0) {
    const maxAttempts = 15 // Reduced from 20 for better UX (1.5 seconds total)

    // Prevent concurrent mounting attempts
    if (this._isMountingPreezie) {
      console.debug('[Preezie] Mount already in progress, skipping attempt')
      return
    }

    this._isMountingPreezie = true
    console.debug(`[Preezie] Mounting attempt ${attempt + 1}/${maxAttempts}`)

    try {
      // Wait for Preezie script to load
      if (typeof window.mountPreezieGBApp !== 'function') {
        this._isMountingPreezie = false

        if (attempt < maxAttempts) {
          // Use exponential backoff for better performance
          const delay = Math.min(100 * Math.pow(1.2, attempt), 1000)
          setTimeout(() => this.mountPreezieWidget(attempt + 1), delay)
        } else {
          console.error('[Preezie] Script not loaded after maximum attempts. Check if Preezie is properly included.')
        }
        return
      }

      // Check if widget is already mounted
      if (document.getElementById('preezie-ai-widget-id-0')) {
        console.debug('[Preezie] Widget already exists, skipping mount')
        this._isMountingPreezie = false
        return
      }

      // Find the container element
      const productFormContainer = document.querySelector('[data-shopassistant-container]')

      if (productFormContainer) {
        // Create widget container
        const pdpDiv = document.createElement('div')
        pdpDiv.id = 'preezie-ai-widget-id-0'
        pdpDiv.setAttribute('data-product-handle', this.dataset.handle || 'unknown')
        productFormContainer.appendChild(pdpDiv)

        // Enhanced configuration with product context
        const config = {
          appType: 'pdp',
          disableShadowDom: false,
          productHandle: this.dataset.handle,
          debug: process.env.NODE_ENV === 'development'
        }

        // Mount the widget
        window.mountPreezieGBApp(config, 'preezie-ai-widget-id-0')

        console.log(`[Preezie] Widget mounted successfully on attempt ${attempt + 1}`, {
          productHandle: this.dataset.handle
        })

        this._isMountingPreezie = false
      } else {
        // Container not found, retry with backoff
        this._isMountingPreezie = false

        if (attempt < maxAttempts) {
          const delay = Math.min(100 * Math.pow(1.2, attempt), 1000)
          console.debug(`[Preezie] data-shopassistant-container not found, retrying in ${delay}ms`)
          setTimeout(() => this.mountPreezieWidget(attempt + 1), delay)
        } else {
          console.warn('[Preezie] Could not find data-shopassistant-container after maximum attempts. Widget not mounted.')
        }
      }
    } catch (error) {
      console.error('[Preezie] Error mounting widget:', {
        error: error.message,
        attempt: attempt + 1,
        productHandle: this.dataset.handle
      })
      this._isMountingPreezie = false

      // Clean up any partial mount on error
      const partialWidget = document.getElementById('preezie-ai-widget-id-0')
      if (partialWidget) {
        partialWidget.remove()
      }
    }
  }
}

register(ProductInfo, 'product-info')
register(ProductVendorModal, 'product-vendor-modal')
register(ProductForm, 'product-form')
register(ProductBadge, 'product-badge')
register(AnchorSection, 'anchor-section')
register(ProductLookBook, 'product-lookbook')
register(ProductShipping, 'product-shipping')

customElements.define('product-main', ProductMain)
